import { css, cva } from "@stubhub/broadway-foundation/css";

export const imageCarousel = css({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
});
export const styledImage = css({
  width: "full",
  borderStartStartRadius: "element.extraSmall",
  borderStartEndRadius: "element.extraSmall",
  borderEndStartRadius: "element.extraSmall",
  borderEndEndRadius: "element.extraSmall",
  transitionProperty: "[opacity]",
  transitionDuration: "[1.25s]",
  transitionTimingFunction: "[ease-in-out]",
  opacity: 1,
});
export const carouselImage = cva({
  base: {
    width: "full",
    borderStartStartRadius: "element.extraSmall",
    borderStartEndRadius: "element.extraSmall",
    borderEndStartRadius: "element.extraSmall",
    borderEndEndRadius: "element.extraSmall",
    transitionProperty: "[opacity]",
    transitionDuration: "[1.25s]",
    transitionTimingFunction: "[ease-in-out]",
    opacity: 1,
  },
  variants: {
    state: {
      active: {},
      inactive: {
        position: "absolute",
        insetBlockStart: "primitives.0",
        insetInlineStart: "primitives.0",
        opacity: 0,
      },
    },
  },
  defaultVariants: {
    state: "active",
  },
});
export const carouselTitle = css({
  marginBlockStart: "primitives.150",
});
export const carouselSection = css({
  marginBlockStart: "primitives.150",
  position: "relative",
});
export const carouselControls = css({
  display: "flex",
  columnGap: "primitives.100",
  rowGap: "primitives.100",
  marginBlockStart: "primitives.150",
  alignSelf: "center",
});
export const carouselControlButtonRecipe = cva({
  base: {
    width: "primitives.100",
    height: "primitives.100",
    borderStartStartRadius: "full",
    borderStartEndRadius: "full",
    borderEndStartRadius: "full",
    borderEndEndRadius: "full",
    backgroundColor: "border.strong",
    cursor: "pointer",
  },
  variants: {
    state: {
      active: {
        backgroundColor: "text",
      },
      inactive: {},
    },
  },
  defaultVariants: {
    state: "inactive",
  },
});
